import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Outlet } from "react-router-dom";
import Loader from "../../Frontend/Layout/Loader";
import logoDark from "../../../../assets/images/logo-dark.webp";
import VendorHeader from "./Header";
import { createLoadingSelector } from "../../../../redux/shared/selector";

function VendorLayout(props) {
    return (
        <div className="vendor-portal">
            {props?.loadingSelector && <Loader />}
            <VendorHeader />
            <Outlet />
            <div className="vp-foot">
                <img
                    className="vp-foot-logo"
                    src={logoDark}
                    alt="HRA — The Power of Collective"
                />
                <span>© {new Date().getFullYear()} HRA. All rights reserved.</span>
            </div>
        </div>
    );
}

const mapStatetoProps = createStructuredSelector({
    loadingSelector: createLoadingSelector(),
});

export default connect(mapStatetoProps)(VendorLayout);
